module.exports = __webpack_public_path__ + "img/mdi-chevron-right.6e48dd80.svg";